import { Environments, CurrentEnvironment } from '../Env.js';

const tealiumSyncTaggingScript = document.createElement('script');

tealiumSyncTaggingScript.src = `${Environments[CurrentEnvironment].analyticsUrl}/utag.sync.js`;

document.head.append(tealiumSyncTaggingScript);
